module.exports = __webpack_public_path__ + "static/media/README.736b2e98.md";